<template>
    <div class="panel panel-default panel-dashboard">
        <div class="panel-heading">
            <h5 class="pull-left">
                Average Price
            </h5>

            <div class="pull-right text-muted" style="padding-top: 5px;">
                {{ year }}
            </div>

            <div class="clearfix"></div>
        </div>

        <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

        <div v-else class="panel-body text-center">
            <span style="font-size: 36px">
                {{ value | price }}
            </span>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import SaveHeight from '@/mixins/SaveHeight'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
    components: {LoadingSpinner},

    mixins: [SaveHeight],

    props: ['year', 'portal', 'user', 'subscriberType'],

    data() {
        return {
            loading: true,
            value: null
        }
    },

    mounted() {
        this.load()
    },

    watch: {
        year() {
            this.load()
        },

        portal() {
            this.load()
        },

        user() {
            this.load()
        },

        subscriberType() {
            this.load()
        }
    },

    computed: {
        filters() {
            let filters = [
                {
                    dimension: 'subscription_start_date',
                    operator: '>=',
                    value: moment().year(this.year).startOf('year').format('YYYY-MM-DD HH:mm:ss')
                },
                {
                    dimension: 'subscription_start_date',
                    operator: '<=',
                    value: moment().year(this.year).endOf('year').format('YYYY-MM-DD HH:mm:ss')
                },
                {dimension: 'subscription_period_price', operator: '>', value: 0}
            ]

            if (this.portal && this.portal.length) {
                filters.push({dimension: 'portal_id', operator: 'in', value: this.portal})
            }

            if (this.user) {
                filters.push({dimension: 'user_id', value: this.user})
            }

            if (this.subscriberType) {
                filters.push({dimension: 'subscriber_type', value: this.subscriberType})
            }

            return filters
        }
    },

    methods: {
        load() {
            this.saveHeight()

            this.loading = true

            this.getRowsPromise()
                .then(response => {
                    if (response.data.data.length) {
                        let row = response.data.data[0]

                        this.value = row.subscription_revenue / row.subscription_count
                    } else {
                        this.value = 0
                    }

                    this.loading = false
                })
        },

        getRowsPromise() {
            return http.post('/api/v1/reports/new-dashboard', {
                metrics: ['subscription_revenue', 'subscription_count'],
                filters: this.filters
            })
        }
    }
}
</script>
